import { ContextualMenu } from '@fluentui/react';
import styled from 'styled-components/macro';

export const StyledContextualMenu = styled(ContextualMenu)`
    .ms-Callout-main {
        overflow: visible;
    }
`;
